module.exports = __webpack_public_path__ + "static/media/06.da43c2ee.jpg";